export const paymentAccounts = {
  // Stripe e Wompi sono DUE integrazioni, non due opzioni della stessa:
  // ognuna ha la sua schermata e la sua intestazione. `tagline` è la
  // riga che colloca (dove incassa e con quali metodi).
  header: {
    stripe: {
      title: "Incassi con Stripe",
      tagline: "Carte internazionali · Spagna e la maggior parte dei paesi",
      description:
        "Collega uno o più conti Stripe e decidi con quale incassa ogni annuncio.",
    },
    wompi: {
      title: "Incassi con Wompi",
      tagline: "Colombia · PSE, Nequi e carte colombiane",
      description:
        "Collega uno o più conti Wompi e decidi con quale incassa ogni annuncio.",
    },
    bold: {
      title: "Pagamenti con Bold",
      tagline: "Colombia e Perù · PSE, Nequi, Bancolombia e carte",
      description:
        "Collega uno o più account Bold e scegli con quale incassa ogni annuncio.",
    },
    redsys: {
      title: "Pagamenti con Redsys",
      tagline: "Spagna · Il POS virtuale della tua banca",
      description:
        "Collega il POS virtuale della tua banca e scegli con quale conto incassa ogni annuncio. Il denaro arriva direttamente sul tuo conto bancario.",
      card: "POS virtuale della tua banca (Spagna)",
    },
  },

  // Wompi dove non serve. Il gateway lo decide il paese dell'ANNUNCIO,
  // non quello del proprietario: per questo si parla di alloggi e non
  // di te.
  notAvailable: {
    title: "Wompi è per gli alloggi in Colombia",
    text: "Wompi incassa in pesos colombiani con PSE, Nequi e carte colombiane. Non hai nessun alloggio lì, quindi qui non c'è niente da collegare.",
    hint: "Se pubblichi un alloggio in Colombia, questa schermata si aprirà da sola.",
    button: "Vai a {provider}",
  },

  session: {
    title: "La tua sessione è scaduta",
    text: "Non si è perso nulla: i tuoi conti di incasso sono ancora collegati. Accedi di nuovo per vederli.",
    button: "Accedi di nuovo",
  },

  status: {
    ready: "Pronto",
    incomplete: "Incompleto",
    unverified: "Non verificato",
  },

  environment: {
    test: "Test",
  },

  accounts: {
    card: {
      title: "I tuoi conti {provider}",
      subtitle: "Collega nuovi conti e controlla se sono pronti a incassare.",
    },
    searchPlaceholder: "Cerca un conto per nome…",
    newButton: "Collega un conto {provider}",
    noName: "Senza nome",
    fallbackName: "Conto #{id}",
    defaultBadge: "Principale",
    listingsCount: "{count} annuncio | {count} annunci",
    empty: {
      none: "Non hai ancora collegato nessun conto {provider}.",
      noMatch: "Nessun conto corrisponde alla ricerca.",
    },
    actions: {
      edit: "Modifica",
      setDefault: "Rendi principale",
      isDefault: "È già quello principale",
      resume: "Completa la registrazione",
      verify: "Verifica",
      disconnect: "Scollega",
    },
  },

  assign: {
    card: {
      title: "Ripartizione per annuncio",
      subtitle: "Scegli quali annunci incassa ogni conto {provider}.",
    },
    searchPlaceholder: "Cerca un annuncio per nome…",
    filter: {
      all: "Tutti",
      unassigned: "Non assegnati",
      notReady: "Non può incassare",
      other: "Incassa con {provider}",
    },
    // Nessun conto assegnato. Quando si sa qual è il principale lo si nomina:
    // è quello che l'host vuole sapere, con quale conto incassa l'annuncio.
    autoOption: "Conto principale",
    autoOptionNamed: "Conto principale · {name}",
    autoOptionOther: "Conto principale {provider} · {name}",
    otherProvider: "Incassa con {provider} · {name}",
    otherProviderLink: "Gestisci in {provider}",
    notReadyRow: "Non incassa",
    notReadyRowTip: "Il conto assegnato a questo annuncio non è ancora pronto, quindi l'ospite non potrà pagare.",
    notReadyAutoRow: "Il conto principale non incassa",
    notReadyAutoRowTip: "Questo annuncio usa il conto principale, che non è ancora pronto. Completalo o assegnagli un altro conto.",
    notReadyBanner: "{count} annuncio non può incassare al momento: il suo conto non è ancora pronto. Gli ospiti non potranno pagarlo finché non completi quel conto. | {count} annunci non possono incassare al momento: il loro conto non è ancora pronto. Gli ospiti non potranno pagarli finché non completi quel conto.",
    notReadyBannerLink: "Vedi quegli annunci",
    defaultSuffix: " (principale)",
    empty: {
      none: "Non hai ancora annunci.",
      noMatch: "Nessun annuncio corrisponde al filtro.",
    },
    count: "Ne vedi {shown} su {total}",
  },

  drawer: {
    newTitle: "Collega un conto {provider}",
    editTitle: "Modifica il conto {provider}",
    subtitle: "Dagli un nome e scegli quali annunci incassa.",
    closeAria: "Chiudi il pannello",

    stripe: {
      title: "Registrazione su Stripe",
      subtitle: "Stripe ti chiederà i tuoi dati e ti riporterà qui.",
      explain:
        "Ti portiamo su Stripe per creare il conto con questo nome e verificare i tuoi dati. Al ritorno potrai scegliere quali annunci incassa; se lasci la registrazione a metà, il conto resta qui e la riprendi quando vuoi.",
      button: "Continua su Stripe",
      connecting: "Apertura di Stripe…",
      resumeTitle: "Registrazione Stripe a metà",
      resumeSubtitle: "Manca finire la verifica su Stripe.",
      resumeExplain: "Questo conto è stato creato ma non ha completato la registrazione su Stripe, perciò non può ancora incassare. Riprendila da dove l'hai lasciata.",
      resumeButton: "Completa la registrazione",
    },

    data: {
      title: "Dati del conto",
      subtitle: "Il nome è solo per te: ti aiuta a distinguerli.",
      label: "Nome del conto",
      labelPlaceholder: "Per esempio: Appartamenti al mare",
      labelHint: "L'ospite non lo vede mai.",
      publicKey: "Chiave pubblica",
      privateKey: "Chiave privata",
      privateKeyKept: "Si conserva quella che avevi già",
      privateKeyHint: "Lascia vuoto per tenere la chiave salvata.",
      stripeId: "Identificativo Stripe",
    },

    listings: {
      title: "Annunci che incassa",
      subtitle: "Quelli che selezioni smetteranno di incassare con il conto precedente.",
      label: "Annunci di questo conto",
      selectedCount: "{selected} su {total} selezionati",
      searchPlaceholder: "Cerca un annuncio…",
      selectAll: "Seleziona tutti",
      clear: "Pulisci",
      takenBy: "ora su {name}",
      noResults: "Nessun annuncio corrisponde alla ricerca.",
      hint: "Gli annunci che non selezioni in nessun conto incassano con quello principale.",
      otherHidden: "Qui non compare {count} annuncio che incassa con {provider}: si gestisce nella sua schermata. | Qui non compaiono {count} annunci che incassano con {provider}: si gestiscono nella loro schermata.",
    },

    footer: {
      isDefault: "È già quello principale",
      setDefault: "Rendi principale",
      disconnect: "Scollega",
      cancel: "Annulla",
      save: "Salva",
      saving: "Salvataggio…",
    },
  },

  disconnect: {
    title: "Scollega il conto",
    subtitle: "Smetterai di incassare con questo conto.",
    confirm:
      "Stai per scollegare «{name}». Le prenotazioni già incassate non cambiano, ma questo conto non accetterà più pagamenti nuovi.",
    blocked:
      "«{name}» incassa ancora {count} annuncio. Prima di scollegarlo bisogna spostarlo su un altro conto. | «{name}» incassa ancora {count} annunci. Prima di scollegarlo bisogna spostarli su un altro conto.",
    moveLabel: "Sposta quegli annunci su",
    moveHint: "Li spostiamo sul conto che scegli e poi scolleghiamo questo.",
    cancel: "Annulla",
    accept: "Scollega",
    seeListings: "Vedi quegli annunci",
    moveAndDisconnect: "Sposta e scollega",
  },

  loading: {
    accounts: "Caricamento dei tuoi conti di incasso…",
  },

  msg: {
    loadError: "Non siamo riusciti a caricare i tuoi conti di incasso.",
    labelRequired: "Dai un nome al conto.",
    publicKeyRequired: "Manca la chiave pubblica di Wompi.",
    privateKeyRequired: "Manca la chiave privata di Wompi.",
    saved: "Conto salvato.",
    saveError: "Non siamo riusciti a salvare il conto.",
    stripeNoUrl: "Stripe non ci ha restituito il link di registrazione. Riprova.",
    stripeConnectError: "Non siamo riusciti ad aprire la registrazione su Stripe.",
    verified: "Il conto è verificato.",
    verifiedWithName: "Conto verificato: {name}.",
    notVerified: "Il conto non è ancora verificato. Controlla le chiavi.",
    verifyError: "Non siamo riusciti a verificare il conto.",
    defaultUpdated: "Ora è il conto principale.",
    defaultError: "Non siamo riusciti a cambiare il conto principale.",
    disconnected: "Conto scollegato.",
    disconnectError: "Non siamo riusciti a scollegare il conto.",
    movedAndDisconnected: "Annunci spostati e conto scollegato.",
    savedNotReady: "Attenzione: questo conto non può ancora incassare e ha {count} annuncio assegnato. Completalo o quell'annuncio resterà senza incassare. | Attenzione: questo conto non può ancora incassare e ha {count} annunci assegnati. Completalo o quegli annunci resteranno senza incassare.",
    assignError: "Non siamo riusciti a cambiare il conto di questo annuncio.",
  },

  integrations: {
    connectedAccounts: "{count} conto collegato | {count} conti collegati",
    notApplicable: "Per gli alloggi in Colombia",
    notApplicableSpain: "Per strutture in Spagna",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Ambiente",
    environmentHint: "La tua banca ti dà dei dati per i test e altri per gli incassi reali. Scegli a quali appartengono quelli che inserisci.",
    env: {
      test: "Test",
      prod: "Reale",
    },
    merchantCode: "Numero esercente (FUC)",
    merchantCodeHint: "Si trova nel contratto del POS o nel modulo di amministrazione di Redsys. Solo cifre, di solito nove.",
    terminal: "Terminale",
    terminalHint: "Quasi sempre 1. Se la banca te ne ha dati diversi, quello del POS virtuale.",
    secretKey: "Chiave di firma (SHA-256)",
    secretKeyHint: "Nel modulo di amministrazione di Redsys → Dati esercente → «Vedi chiave». La verifichiamo con Redsys al salvataggio, senza addebitare nulla.",
    onlyEuro: "Solo euro · incassa in {currency}",
    onlyEuroTip: "Redsys incassa solo in euro. Assegna questa struttura a un altro conto di incasso.",
    msg: {
      merchantCode: "Il numero esercente contiene solo cifre (di solito nove).",
      terminal: "Il terminale è un numero da una a tre cifre (quasi sempre 1).",
      secretKey: "Manca la chiave di firma di Redsys.",
    },
  },
};
